import React from 'react';
import styled from 'styled-components';

const C5Style = styled.svg``;

export const C5 = ({ color }) => {
	return (
		<C5Style
			xmlns='http://www.w3.org/2000/svg'
			width='21.541'
			height='23.718'
			viewBox='0 0 21.541 23.718'
		>
			<path
				id='Drums'
				d='M910.987,506.917H930.82a.856.856,0,0,1,.851.857v2.95a.854.854,0,0,1-.851.857h-.036v5.169a2.218,2.218,0,0,1-2.321,2.05H913.345a2.229,2.229,0,0,1-2.333-2.05v-5.169h-.025a.855.855,0,0,1-.856-.857v-2.95a.857.857,0,0,1,.856-.857Zm9.673-5.65a.535.535,0,0,1,.195.726l-.012.018a.509.509,0,0,1-.315.228.529.529,0,0,1-.639-.349h.006a.518.518,0,0,1,.389-.678.532.532,0,0,1,.375.055Zm.511-.885a1.557,1.557,0,0,0-1.671.073l-6.932-5.059c-1.7-1.309-3.548,1.845-1.6,2.7l7.881,3.494a1.555,1.555,0,0,0,2.874.951l.024-.033a1.562,1.562,0,0,0-.571-2.125Zm-5.067-1.13-4.727-2.1c-.565-.253.054-1.307.558-.951l4.169,3.048Zm5.043,5.293a.536.536,0,0,0-.2.722l.013.019a.545.545,0,0,0,.31.23.529.529,0,0,0,.643-.349h0a.524.524,0,0,0-.388-.68.545.545,0,0,0-.377.058Zm-.511-.888a1.545,1.545,0,0,1,1.665.079l6.939-5.058c1.695-1.31,3.542,1.84,1.6,2.695l-7.881,3.494a1.558,1.558,0,0,1-1.951,1.641,1.537,1.537,0,0,1-.923-.69l-.019-.033a1.55,1.55,0,0,1,.571-2.127Zm5.055-1.127,4.734-2.1c.564-.251-.055-1.309-.554-.95l-4.181,3.046Zm-7.656,9.707-1.975,4.849H920l-1.963-4.849Zm-3.78,4.849-1.526-3.764v3.428c0,.24.444.336.615.336Zm-1.131-5.505,2.03,5,2.035-5Zm5.748,0,2.03,5,2.029-5Zm4.9.656-1.969,4.849h3.939l-1.97-4.849Zm5.3,1.085-1.525,3.764h.918c.17,0,.607-.1.607-.336v-3.428Zm-4.453-1.741,2.023,5,2.03-5Zm5.341-2.95H911.838v1.236h18.119v-1.236Z'
				transform='translate(-910.131 -495.082)'
				fill={color}
			/>
		</C5Style>
	);
};
